import * as C from '../constants/reportingConstants';

const list   = (req, ok, fail) => (state = { loading: false, items: [], error: null }, { type, payload }) => {
    switch (type) {
        case req:  return { ...state, loading: true,  error: null };
        case ok:   return { loading: false, items: payload, error: null };
        case fail: return { loading: false, items: [], error: payload };
        default:   return state;
    }
};

export const reportDataSourceList  = list(C.REPORT_DATASOURCE_LIST_REQUEST,  C.REPORT_DATASOURCE_LIST_SUCCESS,  C.REPORT_DATASOURCE_LIST_FAIL);
export const reportPgFunctionList  = list(C.REPORT_PG_FUNCTIONS_REQUEST,     C.REPORT_PG_FUNCTIONS_SUCCESS,     C.REPORT_PG_FUNCTIONS_FAIL);

export const reportDataSourceDetect = (state = { loading: false, detected: null, error: null }, { type, payload }) => {
    switch (type) {
        case C.REPORT_DATASOURCE_DETECT_REQUEST: return { loading: true,  detected: null, error: null };
        case C.REPORT_DATASOURCE_DETECT_SUCCESS: return { loading: false, detected: payload, error: null };
        case C.REPORT_DATASOURCE_DETECT_FAIL:    return { loading: false, detected: null, error: payload };
        default: return state;
    }
};

export const reportDataSourceSchemas = (state = { loading: false, schemas: [], error: null }, { type, payload }) => {
    switch (type) {
        case C.REPORT_DATASOURCE_SCHEMAS_REQUEST: return { loading: true,  schemas: [], error: null };
        case C.REPORT_DATASOURCE_SCHEMAS_SUCCESS: return { loading: false, schemas: payload, error: null };
        case C.REPORT_DATASOURCE_SCHEMAS_FAIL:    return { loading: false, schemas: [], error: payload };
        default: return state;
    }
};
export const reportFunctionList    = list(C.REPORT_FUNCTION_LIST_REQUEST,    C.REPORT_FUNCTION_LIST_SUCCESS,    C.REPORT_FUNCTION_LIST_FAIL);

export const reportFunctionTemplates = (state = { loading: false, templates: [], categories: {}, error: null }, { type, payload }) => {
    switch (type) {
        case C.REPORT_FUNCTION_TEMPLATES_REQUEST:
            return { ...state, loading: true, error: null };
        case C.REPORT_FUNCTION_TEMPLATES_SUCCESS:
            return {
                loading: false,
                templates: payload?.templates ?? [],
                categories: payload?.categories ?? {},
                error: null,
            };
        case C.REPORT_FUNCTION_TEMPLATES_FAIL:
            return { loading: false, templates: [], categories: {}, error: payload };
        default:
            return state;
    }
};

export const reportDashboardList = (state = { loading: false, items: [], error: null }, action) => {
    switch (action.type) {
        case C.REPORT_DASHBOARD_LIST_REQUEST:
            return { ...state, loading: true, error: null };
        case C.REPORT_DASHBOARD_LIST_SUCCESS:
            return { loading: false, items: action.payload, error: null };
        case C.REPORT_DASHBOARD_LIST_FAIL:
            return { loading: false, items: [], error: action.payload };
        case C.REPORT_DASHBOARD_DELETE_SUCCESS:
            return {
                ...state,
                items: state.items.filter(
                    d => String(d.id ?? d.Id) !== String(action.payload),
                ),
            };
        case C.REPORT_DASHBOARD_CREATE_SUCCESS:
            return {
                ...state,
                items: [...state.items, action.payload].sort(
                    (a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)
                        || String(a.name ?? '').localeCompare(String(b.name ?? '')),
                ),
            };
        case C.REPORT_DASHBOARD_UPDATE_SUCCESS: {
            const updated = action.payload;
            const uid = String(updated?.id ?? updated?.Id ?? '');
            if (!uid) return state;
            return {
                ...state,
                items: state.items.map(d => (
                    String(d.id ?? d.Id) === uid ? { ...d, ...updated } : d
                )),
            };
        }
        default:
            return state;
    }
};

export const reportFunctionDeploy = (state = { loading: false, result: null, error: null }, { type, payload }) => {
    switch (type) {
        case C.REPORT_FUNCTION_DEPLOY_REQUEST: return { loading: true,  result: null, error: null };
        case C.REPORT_FUNCTION_DEPLOY_SUCCESS: return { loading: false, result: payload, error: null };
        case C.REPORT_FUNCTION_DEPLOY_FAIL:    return { loading: false, result: null, error: payload };
        default: return state;
    }
};

export const reportFunctionDescribe = (state = { loading: false, descriptor: null, error: null }, { type, payload }) => {
    switch (type) {
        case C.REPORT_FUNCTION_DESCRIBE_REQUEST: return { loading: true,  descriptor: null, error: null };
        case C.REPORT_FUNCTION_DESCRIBE_SUCCESS: return { loading: false, descriptor: payload, error: null };
        case C.REPORT_FUNCTION_DESCRIBE_FAIL:    return { loading: false, descriptor: null, error: payload };
        case C.REPORT_FUNCTION_DESCRIBE_RESET:   return { loading: false, descriptor: null, error: null };
        default: return state;
    }
};

// Per-chart execution results keyed by functionId
export const reportFunctionResults = (state = {}, { type, payload, meta }) => {
    const id = meta?.functionId;
    if (!id) return state;
    switch (type) {
        case C.REPORT_FUNCTION_EXECUTE_REQUEST: return { ...state, [id]: { loading: true,  result: null, error: null } };
        case C.REPORT_FUNCTION_EXECUTE_SUCCESS: return { ...state, [id]: { loading: false, result: payload, error: null } };
        case C.REPORT_FUNCTION_EXECUTE_FAIL:    return { ...state, [id]: { loading: false, result: null, error: payload } };
        default: return state;
    }
};

export const reportDataSourceQuery = (state = { loading: false, result: null, error: null }, { type, payload }) => {
    switch (type) {
        case C.REPORT_DATASOURCE_QUERY_REQUEST: return { loading: true,  result: null, error: null };
        case C.REPORT_DATASOURCE_QUERY_SUCCESS: return { loading: false, result: payload, error: null };
        case C.REPORT_DATASOURCE_QUERY_FAIL:    return { loading: false, result: null, error: payload };
        case C.REPORT_DATASOURCE_QUERY_RESET:   return { loading: false, result: null, error: null };
        default: return state;
    }
};

export const reportCategoryLabelMapList = list(
    C.REPORT_CATEGORY_LABEL_MAP_LIST_REQUEST,
    C.REPORT_CATEGORY_LABEL_MAP_LIST_SUCCESS,
    C.REPORT_CATEGORY_LABEL_MAP_LIST_FAIL,
);

export const reportDashboardDetails = (state = { loading: false, dashboard: null, error: null }, { type, payload }) => {
    switch (type) {
        case C.REPORT_DASHBOARD_DETAILS_REQUEST: return { loading: true,  dashboard: null, error: null };
        case C.REPORT_DASHBOARD_DETAILS_SUCCESS: return { loading: false, dashboard: payload, error: null };
        case C.REPORT_DASHBOARD_DETAILS_FAIL:    return { loading: false, dashboard: null, error: payload };
        default: return state;
    }
};
